export default __webpack_public_path__ + "static/media/robot-2.850bb17a.png";